import React, { useEffect, useRef, useState } from 'react';
import { useHistory, Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import * as R from "ramda";
import * as Loadings from '../../../constants/loadings/funecap/dossiers';
import { LoadingState } from '../../../_common/loadingState';

import { DossiersFilter } from './filter';
import { DossiersPagination } from './pagination';
import { ChangeCharge } from './../../_common/changeCharge';

export const DossiersMain = ({ dossierState, partnerState, partners, pageSearch, setPageSearch, routerQuery, creationUser, pageQuery, teleconseillers, isPartner, userId }) => {
	const history = useHistory();

	const [usersToDisplay, setUsersToDisplay] = useState(dossierState.items);
	const [partnersToDisplay, setPartnersToDisplay] = useState(partners);
	const creationUsersOptions = { myUsers: "Mes dossiers", allUsers: "Tous les dossiers", }
	const statusOptionsRoute = {
		anticipaNotAccepted: "Non commencé",
		facilitaNotAccepted: "Non commencé",
		anticipaOngoing: "En cours",
		facilitaOngoing: "En cours",
		anticipaFinished: "Complété",
		anticipaYearAndMore: "Contrat d'un an",
		anticipaClosed: "Clôture",
		all: "Tous les dossiers",
		facilitaSending: "A envoyer",
		facilitaOvertime: "Courriers générés",
	};
	const statusOptions = { notStarted: "Non commencé", notAccepted: "En cours", ongoing: "En cours", finished: "Complété", yearAndMore: "Contrat d'un an", all: 'Tous les dossiers', sending: 'A envoyer', overtime: "Courriers générés", archived: "Archivé" };
	const searchRef = useRef();
	let timer = null;

	const [selectedUser, setSelectedUser] = useState(undefined);


	useEffect(() => {
		if (!R.isNil(searchRef.current) && pageSearch !== "") {
			searchRef.current.focus();
		}

		const pageQuery = new URLSearchParams(window.location.search);
		if (pageSearch == "") {
			pageQuery.delete("search")
			history.push(`/funecap/dossiers?${pageQuery.toString()}`);
			return;
		}
		pageQuery.set("search", pageSearch)

		clearTimeout(timer);
		timer = setTimeout(() => {
			history.push(`/funecap/dossiers?${pageQuery.toString()}`);
		}, 1000);


		return () => clearTimeout(timer);

	}, [pageSearch]);

	useEffect(() => {
		setPartnersToDisplay(partners);
	}, [partners]);

	useEffect(() => {
		setUsersToDisplay(dossierState.items);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dossierState]);


	if (window.location.search === "") {
		return (
			<Redirect
				to={`/funecap/dossiers?page=${1}&creationUser=${creationUser}${pageSearch !== "" ? "&search=" + pageSearch : ""}${!R.isNil(routerQuery.partner) ? "&partner=" + routerQuery.partner.id : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${
					routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"
				}${!R.isNil(routerQuery.fromCreationDate) ? "&fromCreationDate=" + routerQuery.fromCreationDate : ""}${!R.isNil(routerQuery.toCreationDate) ? "&toCreationDate=" + routerQuery.toCreationDate : ""}`}
			/>
		);
	}

	return (
		<article className="view-calc pt-3 mb-auto pb-sm pt-gd-3 pt-lg-4">
			<div className="container-fluid">
				<DossiersFilter
					dossierState={dossierState}
					statusOptions={statusOptionsRoute}
					creationUsersOptions={creationUsersOptions}
					searchRef={searchRef}
					pageSearch={pageSearch}
					setPageSearch={setPageSearch}
					partnersToDisplay={partnersToDisplay}
					routerQuery={routerQuery}
					creationUser={creationUser}
					pageQuery={pageQuery}
					teleconseillers={teleconseillers}
					userId={userId}
				/>
			</div>
			<div className="auto-view h-100 mb-auto">
				{dossierState.isLoading.includes(Loadings.FETCHING_DOSSIERS) ? (
					<LoadingState />
				) : (
					<div className="container-fluid">
						{!R.isEmpty(usersToDisplay) ? (
							<section className="block grid-sm grid-sm-min grid-lg-narrow grid-hd-auto">
								{usersToDisplay.map((user) => {
									let dossierTypeName = (user.createdByRepresentative ? "Facilita" : "Anticipa") + (user.hasDocumentSending ? "" : " light");
									if (user.createdByRepresentative && !user.hasDocumentSending && user.isSerenita) {
										dossierTypeName = "Serenita";
									}
									return (
										<div className="card text-center h-100 rounded shadow--hover" key={user.id}>
											<div className="card-body my-auto px-3 pb-1 flex-column">
												{/* <div className="card-body pt-3 pb-2 shadow h-100 rounded mb-2 text-center"> */}
												<Link
													to={() => {
														const pageQuery = new URLSearchParams(window.location.search);
														return `/funecap/dossiers/${user.id}?p=${btoa(pageQuery.toString())}`;
													}}
													className="flex-column my-auto">
													<h4 className="h3 ls-n1 font-weight-black mt-auto mb-2 text-capitalize">
														{user.firstName} {user.lastName}
													</h4>
													<p className="h6 text-uppercase font-weight-bolder mb-0">{user.selfcareId ? <span className="o-40">Espace Famille</span> : ""}</p>
												</Link>
											</div>
											<div className="flex-row fs-2 mx-auto mb-auto justify-content-between align-items-center px-3 w-100 font-weight-bolder py-1 bg-light">
												<div>
													<span className="o-60">Chargé: </span>
													<span className="text-uppercase mx-1">{user.creationUser}</span>
												</div>
												{isPartner ? (
													<button
														className="btn btn-icon btn-action w-2 px-2 my-auto"
														data-toggle="modal"
														data-target="#changeCharge"
														onClick={() => {
															setSelectedUser(user);
														}}>
														<i className="eva eva-edit-2-outline align-middle fs-lead lh-solid m-auto"></i>
													</button>
												) : (
													""
												)}
											</div>

											<div className="card-footer alin-items-center border-light px-2 bg-none">
												<div className="flex-row fs-2 mx-auto mb-auto justify-content-center w-100 font-weight-bolder">
													<span className="o-60">Statut: </span>
													{/* <span className="text-success text-uppercase mx-1">{statusOptions[user.status]}</span> */}
													{statusOptions[user.status] === statusOptions.notStarted && <span className="text-warning text-uppercase mx-1">{statusOptions[user.status]}</span>}
													{/* {statusOptions[user.status] === statusOptions.notAccepted && <span className="text-info text-uppercase mx-1">{statusOptions[user.status]}</span>} */}
													{statusOptions[user.status] === statusOptions.ongoing && <span className="text-success text-uppercase mx-1">{statusOptions[user.status]}</span>}
													{statusOptions[user.status] === statusOptions.finished && <span className="text-info text-uppercase mx-1">{statusOptions[user.status]}</span>}
													{statusOptions[user.status] === statusOptions.sending && <span className="text-info text-uppercase mx-1">{statusOptions[user.status]}</span>}
													{/* {statusOptions[user.status] === statusOptions.archived && <span className="text-info text-uppercase mx-1">{statusOptions[user.status]}</span>} */}
													{statusOptions[user.status] === statusOptions.overtime && <span className="text-danger text-uppercase mx-1">{statusOptions[user.status]}</span>}
													{statusOptions[user.status] !== statusOptions.notStarted &&
														statusOptions[user.status] !== statusOptions.notAccepted &&
														statusOptions[user.status] !== statusOptions.ongoing &&
														statusOptions[user.status] !== statusOptions.finished &&
														statusOptions[user.status] !== statusOptions.sending &&
														statusOptions[user.status] !== statusOptions.overtime && <span className="text-uppercase mx-1">{statusOptions[user.status]}</span>}
												</div>
											</div>
										</div>
									);
								})}
							</section>
						) : (
							<div className="flex-column p-3 mt-5 h-100 ">
								<div className="container container-base text-center m-auto">
									<h5 className="sr-only visually-hidden">Agent - Empty</h5>
									<div className="display-4 font-weight-black ls-n1 lh-1 mb-3">Aucun résultat</div>
									<p className="text-lg mb-4 o-66">Veuillez vérifier que les filtres appliqués correspondent bien à votre recherche.</p>
								</div>
							</div>
						)}
					</div>
				)}
				{/* <EnvoisProfile /> */}
				<ChangeCharge selectedUser={selectedUser} users={teleconseillers} isLoading={dossierState.isLoading}></ChangeCharge>
			</div>
			<div className="container-fluid">
				<DossiersPagination dossierState={dossierState} pageSearch={pageSearch} routerQuery={routerQuery} />
			</div>
		</article>
	);
};